import React from 'react';
import styles from './ClassicSpinner.css';

export const ClassicSpinner = () => (
    <div className={styles.ClassicSpinner}><div></div><div></div><div></div><div></div></div>
);


// WEBPACK FOOTER //
// ./src/components/UI/Loader/ClassicSpinner.js